import { Loading } from "components/Loading";
import { StyledFlex } from "./styles";
import { CircleImage } from "views/Profile/ChangePasswordModal/styles";
import { CONFIG_OPTION_TYPES } from "api/bookAppointmentOnline/get-config-option";
import WidgetForm from "components/BookAppointmentOnlineWidget/Form/WidgetForm";
import spacing from "theme/spacing.module.scss";
import useGetConfigurationOption from "hooks/bookAppointmentOnline/usegetConfigurationOption.hook";

export default function AppointmentBookOnlineWidgetView() {
    const { data, isFetching, error } = useGetConfigurationOption(
        [
            CONFIG_OPTION_TYPES.OPTION,
            CONFIG_OPTION_TYPES.REDIRECT_URL,
            CONFIG_OPTION_TYPES.REDIRECT_ON_CLICK,
            CONFIG_OPTION_TYPES.AGREEMENT_CONSENT,
            CONFIG_OPTION_TYPES.PERSONAL_DATA_CONSENT,
            CONFIG_OPTION_TYPES.MARKETING_CONSENT,
        ]
    );

    return (
    <StyledFlex vertical justify="center" gap={spacing.spacingLG}>
        <Loading isLoading={isFetching} />
        <CircleImage />
        {data && (
            <WidgetForm
                selectOption={data?.data?.Option}
                redirectUrl={data?.data?.RedirectUrl}
                redirectOnClick={data?.data?.RedirectOnClick}
                agreementConsent={data?.data?.AgreementConsent}
                personalDataConsent={data?.data?.PersonalDataConsent}
                marketingConsent={data?.data?.MarketingConsent}
            />
        )}
    </StyledFlex>
    );
}
